import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cardNumber", "amount", "cardFields", "sbpFields", "phoneNumber", "paymentMethodRadio"]

  connect() {
    if (this.hasCardNumberTarget) this.formatCardNumber()
    if (this.hasAmountTarget) this.formatAmount()
    this.togglePaymentFields()
  }

  togglePaymentFields() {
    const method = this.selectedPaymentMethod()

    if (this.hasCardFieldsTarget && this.hasSbpFieldsTarget) {
      if (method === "sbp") {
        this.cardFieldsTarget.classList.add("hidden")
        this.sbpFieldsTarget.classList.remove("hidden")
        // Disable card field, enable phone
        if (this.hasCardNumberTarget) {
          this.cardNumberTarget.removeAttribute("required")
          this.cardNumberTarget.disabled = true
        }
        if (this.hasPhoneNumberTarget) {
          this.phoneNumberTarget.setAttribute("required", "")
          this.phoneNumberTarget.disabled = false
        }
      } else {
        this.cardFieldsTarget.classList.remove("hidden")
        this.sbpFieldsTarget.classList.add("hidden")
        if (this.hasCardNumberTarget) {
          this.cardNumberTarget.setAttribute("required", "")
          this.cardNumberTarget.disabled = false
        }
        if (this.hasPhoneNumberTarget) {
          this.phoneNumberTarget.removeAttribute("required")
          this.phoneNumberTarget.disabled = true
        }
      }
    }
  }

  selectedPaymentMethod() {
    if (!this.hasPaymentMethodRadioTarget) return "card"
    const checked = this.paymentMethodRadioTargets.find(r => r.checked)
    return checked ? checked.value : "card"
  }

  formatCardNumber() {
    if (!this.hasCardNumberTarget) return

    const digits = this.cardNumberTarget.value.replace(/\D/g, "").slice(0, 19)
    this.cardNumberTarget.value = digits.replace(/(.{4})/g, "$1 ").trim()
  }

  formatPhoneNumber() {
    if (!this.hasPhoneNumberTarget) return

    let digits = this.phoneNumberTarget.value.replace(/\D/g, "")

    // 8 -> 7
    if (digits.startsWith("8") && digits.length <= 11) {
      digits = "7" + digits.slice(1)
    }

    // Ensure starts with 7
    if (!digits.startsWith("7") && digits.length > 0) {
      digits = "7" + digits
    }

    digits = digits.slice(0, 11)

    // Format: +7 999 123 45 67
    let formatted = ""
    if (digits.length > 0) formatted = "+" + digits.slice(0, 1)
    if (digits.length > 1) formatted += " " + digits.slice(1, 4)
    if (digits.length > 4) formatted += " " + digits.slice(4, 7)
    if (digits.length > 7) formatted += " " + digits.slice(7, 9)
    if (digits.length > 9) formatted += " " + digits.slice(9, 11)

    this.phoneNumberTarget.value = formatted
  }

  formatAmount() {
    if (!this.hasAmountTarget) return

    let raw = this.amountTarget.value

    // Запятую → точку
    raw = raw.replace(/,/g, ".")

    // Убираем всё кроме цифр и точки
    raw = raw.replace(/[^\d.]/g, "")

    // Оставляем только первую точку
    const parts = raw.split(".")
    let intPart = parts[0] || ""
    let decPart = parts.length > 1 ? parts.slice(1).join("") : null

    if (!intPart.length && (decPart === null || !decPart.length)) {
      this.amountTarget.value = ""
      return
    }

    // Убираем ведущие нули (но оставляем "0" для "0.5")
    intPart = intPart.replace(/^0+(?=\d)/, "")

    // Форматируем целую часть с пробелами-разделителями тысяч
    const formatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ")

    // Ограничиваем дробную часть 2 знаками
    if (decPart !== null) {
      decPart = decPart.slice(0, 2)
      this.amountTarget.value = formatted + "." + decPart
    } else {
      this.amountTarget.value = formatted
    }
  }

  // Before submit: copy phone to card_number hidden field for SBP
  submitForm(event) {
    const method = this.selectedPaymentMethod()
    if (method === "sbp" && this.hasPhoneNumberTarget && this.hasCardNumberTarget) {
      // Strip formatting, keep only digits with +
      const digits = this.phoneNumberTarget.value.replace(/\D/g, "")
      this.cardNumberTarget.disabled = false
      this.cardNumberTarget.value = "+" + digits
    }
  }
}
